
document.addEventListener("DOMContentLoaded", function() {
  const section = document.getElementById("cstm-prd-list-container");
  if (!section) return;

  const tabs = section.querySelectorAll(".prd-tab-button");
  const contents = section.querySelectorAll(".prd-tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("mouseenter", function() {
      tabs.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");

      let target = this.getAttribute("data-tab");

      contents.forEach(content => {
        content.classList.remove("active");
        if (content.id === target) {
          content.classList.add("active");
        }
      });
    });
  });
});
